import { styles } from "@/config/project";
import { Box, Paper, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

interface IProps {
    total: number;
    title: string;
}

export const TotalPaper = ({ total, title }: IProps) => {
    const theme = useTheme();
    const responsive = useMediaQuery(theme.breakpoints.down("lg"));
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <Paper
            variant="outlined"
            sx={{
                bgcolor: styles.tertiaryColor,
                width: "100%",
                flexGrow: 0,
            }}
        >
            <Box
                py={{ xs: 2, lg: 3 }}
                px={{ xs: 2, lg: 4 }}
                height="100%"
                display="flex"
                flexDirection={"column"}
                justifyContent={"center"}
                gap={1}
            >
                <Typography
                    variant={responsive ? "h4" : "h2"}
                    color={theme.palette.primary.main}
                    fontWeight={isMobile ? 300 : 400}
                >
                    {total}
                </Typography>
                <Typography
                    variant={responsive ? "body2" : "h6"}
                    color={theme.palette.primary.main}
                >
                    {title}
                </Typography>
            </Box>
        </Paper>
    );
};
